function showFlashMessage(message, type = "info", duration = 4000) {
    const container = document.getElementById("flash-container");
    if (!container) return;

    const msg = document.createElement("div");
    msg.classList.add("flash-message", `flash-${type}`);
    msg.innerText = message;

    container.appendChild(msg);

    setTimeout(() => msg.classList.add("show"), 10);

    setTimeout(() => {
        msg.classList.remove("show");
        setTimeout(() => msg.remove(), 400);
    }, duration);
}

document.addEventListener("DOMContentLoaded", function() {
    var flash = document.getElementById("flash-popup");
    if (flash) {
        // Visa
        flash.classList.add("show");
        // Dölj efter 4 sekunder
        setTimeout(function() {
        flash.classList.remove("show");
        }, 4000);
    }
});
